import VerticalPage from "../components/VerticalPage";
import { usePageTitle } from "../hooks/usePageTitle";

const CONFIG = {
  verticalSlug: "pest-control",
  eyebrow: "Built for Pest Control & Exterminators",
  headline: "Book more pest control jobs.",
  headlineHighlight: "Never miss a follow-up.",
  sub: "When a customer has a pest problem, they need a response now. CleanBid delivers quotes via SMS in under 60 seconds, follows up automatically on open estimates, and turns every completed job into a 5-star review.",
  quoteCard: {
    service: "Quarterly Treatment Plan",
    size: "2,100 sqft home",
    price: "$149",
  },
  problems: [
    {
      title: "Urgency Decides Who Wins",
      body: "Pest control is an urgent call. Customers want a price in minutes, not hours. If you're the third company to respond, you're probably not getting the job — no matter how good your service is.",
    },
    {
      title: "Recurring Revenue Slips Away",
      body: "Quarterly treatments are your bread and butter — but only if you stay top of mind. Without follow-up automation, recurring customers drift to whoever calls first in the spring.",
    },
    {
      title: "Trust Lives in Reviews",
      body: "People let you into their home. Reviews are how they decide who to trust. Every job you complete without asking is a missed chance to build the reputation that wins the next one.",
    },
  ],
  features: [
    {
      badge: "Instant SMS Quotes",
      headline: "Respond to urgent pest inquiries in under 60 seconds.",
      body: "When a customer reaches out about a problem, speed wins. CleanBid lets you send a professional treatment quote via SMS before your competition even picks up the phone.",
    },
    {
      badge: "Follow-Up Automation",
      headline: "Not every customer books on the first contact. CleanBid handles the follow-up.",
      body: "Timed, professional follow-up messages go out automatically after every quote — day 1, day 3, day 5 — until the customer responds. You stay focused on the job.",
    },
    {
      badge: "Review Requests",
      headline: "Mark the job done. Review request sent.",
      body: "CleanBid sends the review request automatically when you complete a treatment. Sent while the job is still fresh. No awkward ask. Just reviews building your Google presence.",
    },
  ],
  testimonial: {
    quote: "I used to lose at least 2 jobs a week to faster competitors. CleanBid changed that completely. I respond in under a minute now.",
    name: "Brian T.",
    role: "Pest Control, Tampa FL",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=60&h=60&fit=crop&crop=face",
  },
  ctaBadge: "Ready to close faster and build your reputation?",
  heroImage: {
    src: "https://cdn.searchlegends.com/kro-website/pest-control.jpg",
    alt: "Professional pest control technician",
  },
};

export default function ForPestControlPage() {
  usePageTitle("CleanBid for Pest Control Businesses");
  return <VerticalPage config={CONFIG} />;
}
